let movidesk = document.createElement('script')
movidesk.setAttribute(
    'src',
    'https://chat.movidesk.com/Scripts/chat-widget.min.js'
)

movidesk.type = 'text/javascript'
document.getElementsByTagName('head')[0].appendChild(movidesk)
